import {
  Avatar,
  Box,
  Button,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";
import api from "../../config/axios"; // your axios instance with interceptors

function CreatePostSection({ onPostCreated }) {
  const [postText, setPostText] = useState("");

  const createPostButtons = [
    { iconSrc: "/icons/live-vedio.svg", btnText: "Live Video" },
    { iconSrc: "/icons/photo-vedio.svg", btnText: "Photo / Video" },
    { iconSrc: "/icons/feeling-activity.svg", btnText: "Feeling Activity" },
    { iconSrc: "/icons/camera.svg", btnText: "Camera" },
  ];

  const handleCreatePost = async () => {
    try {
      if (!postText.trim()) {
        alert("Please enter some text before posting.");
        return;
      }
      // Make a request to our backend to create a post
      const response = await api.post("/posts", {
        text: postText,
        // If you want to handle media or feelings, pass them here too
      });

      // The newly created post:
      const newPost = response.data.post;
      console.log("Post created:", newPost);

      // Call the callback to let the parent know a post was created
      if (onPostCreated) {
        onPostCreated(newPost);
      }

      // Clear the text field
      setPostText("");
      alert("Post created successfully!");
    } catch (error) {
      console.error("Error creating post:", error);
      alert(error?.response?.data?.message || "Error creating post");
    }
  };

  return (
    <Stack
      direction="column"
      id="create-post"
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "24px",
        px: "20px",
        py: "16px",
      }}
    >
      <Button
        variant="text"
        startIcon={
          <Box
            component="img"
            src="/icons/create-post.svg"
            sx={{ width: "21px", height: "21px" }}
          />
        }
        sx={{
          minWidth: "auto",
          width: "auto",
          fontSize: "12px",
          color: "#000000",
          textTransform: "none",
          px: "0px",
          "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "&:active": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "&:focus": {
            outline: "none",
          },
          "& .MuiButton-startIcon": {
            m: "0px",
            mr: "6px",
          },
          py: "0px",
          color: "#BCBCBC",
          pb: "10px",
          alignSelf: "start",
          "& .MuiButtonBase-root": {
            width: "auto",
            minWidth: "0",
            padding: "0px",
          },
        }}
      >
        Create Post
      </Button>

      <TextField
        placeholder="What's on your mind?"
        fullWidth
        value={postText}
        onChange={(e) => setPostText(e.target.value)}
        sx={{
          input: {
            bgcolor: "#F9F9F9",
            color: "#000000",
            fontSize: "14px",
            boxSizing: "content-box",
            px: "20px",
            py: "15px",
            borderRadius: "50px",
            "&::placeholder": {
              color: "#000000",
              opacity: 1,
            },
          },
          "& .MuiOutlinedInput-root": {
            px: "0px",
            "& fieldset": {
              border: "none",
            },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment sx={{ pr: "6px" }} position="start">
              <Avatar
                src="/images/navbar-profile-pic.jpeg"
                alt="Profile Picture"
                sx={{
                  width: 42,
                  height: 42,
                  objectFit: "cover",
                  mr: "6px",
                }}
              />
            </InputAdornment>
          ),
        }}
      />

      <Stack
        id="create-post-container-btns"
        direction="row"
        sx={{
          pt: "20px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Stack id="btns" direction="row" spacing={1}>
          {createPostButtons.map((btn, index) => (
            <Button
              key={index}
              variant="text"
              startIcon={<Box component="img" src={btn.iconSrc} />}
              sx={{
                fontSize: "14px",
                color: "#000000",
                textTransform: "none",
                "& .MuiButton-startIcon": {
                  marginRight: "6px",
                },
                borderRadius: "8px",
                py: "0px",
              }}
              onClick={() => {
                // In the future, handle media or live video
                alert(`You clicked: ${btn.btnText}`);
              }}
            >
              {btn.btnText}
            </Button>
          ))}
        </Stack>
        <Button
          variant="outlined"
          sx={{
            py: "8px",
            px: "24px",
            border: "1px solid #4E4E4E",
            bgcolor: "#ffffff",
            color: "#000000",
            textTransform: "none",
            borderRadius: "50px",
          }}
          onClick={handleCreatePost}
        >
          Post
        </Button>
      </Stack>
    </Stack>
  );
}

export default CreatePostSection;
